import { pgTable, varchar, timestamp, integer, jsonb, index } from "drizzle-orm/pg-core";
import { sql } from "drizzle-orm";

export const adsManagerRefreshRuns = pgTable("ads_manager_refresh_runs", {
  id: varchar("id").primaryKey(),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
});
export const adsManagerRefreshJobs = pgTable("ads_manager_refresh_jobs", {
  id: varchar("id").primaryKey(),
  brandId: varchar("brand_id").notNull().unique(),
  accountId: varchar("account_id").notNull(),
  state: varchar("state").notNull().default("pending"),
  token: varchar("token"),
  leaseUntil: timestamp("lease_until", { withTimezone: true }),
  availableAt: timestamp("available_at", { withTimezone: true }).notNull().defaultNow(),
  startedAt: timestamp("started_at", { withTimezone: true }).notNull().defaultNow(),
  updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
  passes: integer("passes").notNull().default(0),
  progress: jsonb("progress").notNull().default(sql`'{}'::jsonb`),
}, table => [index("ads_manager_refresh_jobs_due").on(table.state, table.availableAt)]);
export const adsManagerRefreshDispatch = pgTable("ads_manager_refresh_dispatch", {
  id: varchar("id").primaryKey(),
  runId: varchar("run_id").notNull().references(() => adsManagerRefreshRuns.id),
  brandId: varchar("brand_id").notNull(),
  state: varchar("state").notNull().default("undispatched"),
  jobId: varchar("job_id"),
  reason: varchar("reason"),
}, table => [index("ads_manager_refresh_dispatch_run").on(table.runId)]);
export const adsManagerRefreshWorkers = pgTable("ads_manager_refresh_workers", {
  id: varchar("id").primaryKey(),
  heartbeatAt: timestamp("heartbeat_at", { withTimezone: true }).notNull().defaultNow(),
});
